import { render, staticRenderFns } from "./AdressEdit.vue?vue&type=template&id=51966bc0&"
import script from "./AdressEdit.vue?vue&type=script&lang=js&"
export * from "./AdressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports